import {showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {useGetOtomotoPlatformQuery, useOtomotoAuthenticateMutation} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationForm,
  PlatformAuthenticationFormProps,
} from './PlatformAuthenticationForm';
import {PlatformPhotoSettings} from './PlatformPhotoSettings';
import {PlatformSettingsPromptBridge} from './PlatformSettingsPromptBridge';

export function PlatformSettingsOtomoto() {
  return (
    <>
      <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_OTOMOTO_PROMPT_BRIDGE}>
        <PlatformSettingsPromptBridge code={AdvertisingPlatformCodeEnum.OTOMOTO} />
      </Show>
      <Show whenFeatureDisabled={featureFlags.ADVERTISEMENT_OTOMOTO_PROMPT_BRIDGE}>
        <PlatformCredentialsOtomotoLegacy />
      </Show>
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.OTOMOTO} />
    </>
  );
}

function PlatformCredentialsOtomotoLegacy() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetOtomotoPlatformQuery({params});
  const [saveAuthentication] = useOtomotoAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormProps['onSubmit'] = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <PlatformAuthenticationForm
      values={data?.credentials}
      isFetching={isFetching}
      isError={isError}
      onSubmit={onSubmitCredentials}
    />
  );
}
